import { makeAutoObservable } from 'mobx';
import { IAlgoliaSearchService } from '../../data/types/IAlgoliaSearchService';
import { IEntrySearchResultResponse } from '../../data/types/IEntrySearchResultResponse';

import { IContentSearchResult } from '../types/IContentSearchResult';
import { ISearchPagination } from '../types/ISearchPagination';

export type ContentSearchStore = ReturnType<typeof createContentSearchStore>;

export interface IContentSearchStore {
	algoliaSearchService: IAlgoliaSearchService;
	airportTag: string;
	offset: number;
}

export function createContentSearchStore({
	algoliaSearchService,
	airportTag,
	offset = 20,
}: IContentSearchStore) {
	return makeAutoObservable({
		loading: false,
		userQuery: '',
		content: [] as IContentSearchResult[],
		pagination: {} as ISearchPagination,
		offset,
		reset() {
			this.setUserQuery('');
			this.setContent([]);
		},
		setUserQuery(userQuery: string) {
			this.userQuery = userQuery;

			if (this.userQuery) {
				this.fetchContentResults();
			}
		},

		async fetchContentResults(refresh = true) {
			if (refresh) {
				this.loading = true;
			}
			const results = await algoliaSearchService.getSearchResults(
				this.userQuery,
				airportTag,
				this.offset,
			);

			const searchResults = results.hits?.map(mapResultToContentSearchResult);

			this.setContent(searchResults);
			this.setPagination({
				nbHits: results.nbHits,
				nbPages: results.nbPages,
				page: results.page,
				hitsPerPage: results.hitsPerPage,
			});
			this.loading = false;
		},
		setContent(content: IContentSearchResult[]) {
			this.content = content;
		},
		setPagination(pagination: ISearchPagination) {
			this.pagination = pagination;
		},
		bumpOffset() {
			this.offset += 20;
			this.fetchContentResults(false);
		},
	});
}

function mapResultToContentSearchResult(
	result: IEntrySearchResultResponse,
): IContentSearchResult {
	return {
		pageId: result.pageId,
		slug: result.slug,
		id: result.objectID,
		// eslint-disable-next-line no-underscore-dangle
		snippet: result._snippetResult,
	};
}
